export default __webpack_public_path__ + "static/media/confesiones3.6031a9f5.png";